<style>
.ivu-radio-group{
  display: block;
  margin-bottom: 10px;
}
</style>
<template>
  <Layout>
    <Content :style="{'padding': '10px'}">
      <Breadcrumb :style="{margin: '5px 0'}">
        <BreadcrumbItem>代理商管理 > <b>代理商列表</b></BreadcrumbItem>
      </Breadcrumb>
      <Card :style="{'padding':'0px 5px','margin-bottom':'5px'}">
		  <span class="search_span_width">
				<span class="search_span_width_part1">等级：</span>
				<Select v-model="search.grade" style="width:100px">
					<Option value="1" :key="1">一级</Option>
					<Option value="2" :key="2">二级</Option>
					<Option value="3" :key="3">三级</Option>
				</Select>
		  	</span>
            <span class="search_span_width">
                <span class="search_span_width_part1">手机号：</span>
              <Input v-model="search.mobile" placeholder="请输入手机号" :style="{'width':'110px'}"></Input>
            </span>
        <Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="getAgentList(1)">搜索</Button>
      </Card>
      <Card>
        <p :style="{'margin':'5px 10px 10px 20px','clear':'both','overflow':'hidden'}">
			<span :style="{'text-align':'center','float':'left'}">
				<Button type='primary' :style="{'margin-left':'5px'}" @click="addAgentModal()">添加代理商</Button>
			</span>
        </p>
        <Card id="tableContent" >
          <Table :columns="tableColumns" row-key="id" update-show-children 
		   :load-data="handleLoadData" :data="agent_list"></Table>
          <Page :total="recordTotal" :current="page" :page-size="10" :show-elevator="true" @on-change="getAgentList()"/>
        </Card>
      </Card>
    </Content>
   <Modal v-model="showmodal" :footer-hide=true title="代理商信息">
        <Form ref="agent" :model="agent" :label-width="80" :rules="userRule" >
			<FormItem label="等级" prop="grade">
			<Select v-model="agent.grade" style="width:100px">
				<Option value="1" :key="1">一级</Option>
				<Option value="2" :key="2">二级</Option>
				<Option value="3" :key="3">三级</Option>
			</Select>
			</FormItem>
            <FormItem label="名称" prop="agent_name">
                <Input  v-model="agent.agent_name"/>
            </FormItem>
            <FormItem label="手机号" prop="mobile">
                <Input type="tel" v-model="agent.mobile"/>
            </FormItem>
            <FormItem label="公司名称" prop="company">
                <Input v-model="agent.company"  />
            </FormItem>
            <FormItem label="渠道" prop="channel">
              <Input v-model="agent.channel"  />
            </FormItem>
            <FormItem>
                <Button type="primary" @click="upsertAgent()">提交</Button>
            </FormItem>
        </Form>
    </Modal>
	<Modal v-model="showRecharge" :footer-hide="true" title="充值">
	   <Form ref="recharge" :model="recharge" :label-width="80">
			<FormItem label="金币" prop="total">
				 <Input v-model="recharge.coin_surplus" placeholder="输入需要充值的金币" style="width: 250px" ></Input>
			 </FormItem>
			 <FormItem label="时长" prop="video_duration">
			 	 <Input v-model="recharge.video_duration" placeholder="输入时长" style="width: 250px" ></Input>
			 </FormItem>
       <FormItem label="用户数" prop="user_total_num">
         <Input v-model="recharge.user_total_num" placeholder="输入用户数" style="width: 250px" ></Input>
       </FormItem>
			<FormItem>
			<Button @click="closeModal" style="margin-left: 8px">取消</Button>&nbsp;&nbsp;&nbsp;&nbsp;
			<Button type="primary" @click="updateScore()">提交</Button>
			</FormItem>
	  </Form>
	</Modal>
  </Layout>
</template>
<script>
export default {
  data(){
    return {
		search:{
			mobile:"",
			grade:'1'
		},
      showmodal:false,
	  showRecharge:false,
      agent_list:[],
      recordTotal:0,
      page:1,
	  agent:{
		  id:0,
		  agent_name:"",
		  company:'',
      channel:'',
		  mobile:'',
		  grade:"1"
	  },
	  recharge:{
		  agent_id:0,
		  total:0,
		  discount:0,
		  video_duration:0,
      coin_surplus:0,
      user_total_num:0
	  },
	  userRule :{
		mobile:[
             { required: true, message: "请输入手机号码", trigger: "blur" },
             { pattern: /^1[3456789]\d{9}$/, message: "手机号码格式不正确", trigger: "blur" }
		],
		company: [
			{ required: true, message: '公司名称不能为空', trigger: 'blur' }
		],
		agent_name: [
			{ required: true, message: '请输入名称', trigger: 'blur' }
		]
	  },
      tableColumns:[
        { title: '用户ID', key: 'id', align: 'center',tree: true },
        { title: '昵称', key: 'agent_name', align: 'center' },
        { title: '公司名称', key: 'company', align: 'center' },
		{ title: '代理等级', key: 'grade', align: 'center', render:(h,params) =>{
			 let sub_type = '';
		    if (params.row.grade == '1') {
				sub_type = '一级';
			}else if (params.row.grade == '2') {
				sub_type = '二级';
			}else if (params.row.grade == '3') {
				sub_type = '三级';
			}
			return h('span',{},sub_type);
		 }},
        { title: '剩余可添加用户数', key: 'video_duration', align: 'center',render:(h,params) =>{
            let user_surplus_num = params.row.user_total_num-params.row.user_added_num;
            return h('span',{},user_surplus_num);
          } },
/*		{ title: '剩余金币', key: 'coin_surplus', align: 'center',render:(h,params) =>{
        let coin_surplus_num = (params.row.coin_surplus/100).toFixed(2);
        return h('span',{},coin_surplus_num);
      }},*/
		{ title: '剩余时长', key: 'video_duration', align: 'center' },
		{ title: '创建时间', key: 'created_at', align: 'center'},
        { title: '操作', key: 'action', align: 'center',
          render: (h, params) => {
            let btns=[]
            btns.push(
                h('Button', {
                  props: { type: 'warning', size: 'small' },
                  style: { marginRight: '5px', marginBottom: '5px'},
                  on: {
                    click: () => {        
                      this.agent.id = params.row.id;
					  this.agent.mobile = params.row.mobile;
					  this.agent.agent_name = params.row.agent_name;
					  this.agent.company = params.row.company;
					  this.agent.grade = params.row.grade;
					  this.showmodal = true;
                    }
                  }
                }, '编辑'),
            );
			btns.push(
			    h('Button', {
			      props: { type: 'success', size: 'small' },
			      style: { marginRight: '5px', marginBottom: '5px'},
			      on: {
			        click: () => {        
						this.recharge.agent_id = params.row.id;
						this.recharge.coin_surplus = 0;
						this.recharge.discount = 0;
						this.recharge.video_duration = 0;
						this.showRecharge = true;
			        }
			      }
			    }, '充值'),
			);
            return h("div",btns);
          }
        }
      ],
    }
  },
  mounted:function(){
		this.getAgentList();
  },
  computed:{
  },
  methods:{
		addAgentModal(){
			this.agent.id = 0;
			this.agent.agent_name = '';
			this.agent.mobile = '';
			this.agent.company = '';
			this.agent.grade = 1;
			this.showmodal = true;
		},
		getAgentList(page=this.page) {
			this.page = page;
			let p = {'page' : page}
			let params = Object.assign(this.search, p);
			this.http.get('/admin/agent/agList',{params:params}).then(response=>{
			  let data=response.data;
			  if(data.code!==0)
			  {
				alert(data.message);
			  } else{
				this.agent_list = data.data.list;
				this.recordTotal = data.data.total;
			  }
			}).catch(()=>{
			  this.$Message.error('网络错误');
			});
		},
		upsertAgent() {
			this.http.post('/admin/agent/upsertAgent',this.agent).then(response=>{
			  let data=response.data;
			  if(data.code!==0)
			  {
				alert(data.message);
			  } else{
				this.getAgentList(this.page);
				this.showmodal = false;
			  }
			}).catch(()=>{
			  this.$Message.error('网络错误');
			});
		},
		updateScore() {
			this.http.post('/admin/agent/upsertRecharge',this.recharge).then(response=>{
			  let data=response.data;
			  if(data.code!==0)
			  {
				alert(data.message);
			  } else{
				this.getAgentList(this.page);
				this.recharge.agent_id = 0;
				this.showRecharge = false;
			  }
			}).catch(()=>{
			  this.$Message.error('网络错误');
			});
		},
		handleLoadData (item, callback) {
			this.http.get('/admin/agent/agList',{params:{up_id:item.id}}).then(response=>{
			  let data=response.data;
			  if(data.code!==0)
			  {
				alert(data.message);
			  } else{
				callback(data.data.list);
			  }
			}).catch(()=>{
			  this.$Message.error('网络错误');
			});
		},
		closeModal(){
		  this.showmodal=false;
		}
	}
}
</script>
